import React from 'react';
import styled from 'styled-components';

export interface FAIconProps {
  /**
   * Name of the icon.
   * [Search icons](https://fontawesome.com/search?q=range&ip=classic&s=regular%2Csolid)
   */
  icon: string;

  /**
   * Icon Family.
   * Currently only 'classic' is supported. Add more in `public/assets/fontawesome` if needed.
   * [Families & styles](https://docs.fontawesome.com/web/add-icons/how-to#families--styles)
   * @default 'classic'
   */
  family?: 'classic';

  /**
   * Icon style.
   * Currently only 'solid' and 'regular' are supported. Add more in `public/assets/fontawesome` if needed.
   * [Families & styles](https://docs.fontawesome.com/web/add-icons/how-to#families--styles)
   * @default 'solid'
   */
  type?: 'solid' | 'regular';

  /**
   * Icon size
   * [Sizing icons](https://docs.fontawesome.com/web/style/size)
   * @default undefined (inherits from parent)
   */
  size?: '2xs' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl';

  /**
   * Icon color.
   * @default undefined (inherits from parent)
   */
  color?: string;

  /**
   * Additional CSS class names
   */
  className?: string;
}

const StyledIcon = styled.i<{ $color?: string }>`
  ${({ $color }) => $color && `color: ${$color};`}
`;

const FAIcon: React.FC<FAIconProps> = ({
  icon,
  family = 'classic',
  type = 'solid',
  size = 'lg',
  color,
  className,
}) => {
  const classNames: string[] = [];

  // Add family and type classes
  const typePrefix = type === 'solid' ? 'fa-solid' : 'fa-regular';
  classNames.push(typePrefix);

  // Add icon name
  classNames.push(`fa-${icon}`);

  // Add size if specified
  if (size) {
    classNames.push(`fa-${size}`);
  }

  // Add custom className if provided
  if (className) {
    classNames.push(className);
  }

  return <StyledIcon className={classNames.join(' ')} $color={color} />;
};

export default FAIcon;
